// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/';
const ROOTS_AUTH = '/auth';
// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
  downloadEndPeriodReport: path(ROOTS_AUTH, '/landing/end-period-report')
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  end_user: {
    dashboard: path(ROOTS_DASHBOARD, '/end-user'),
    deliver: {
      new: path(ROOTS_DASHBOARD, '/end-user/deliver/new')
    },
    devices: {
      root: path(ROOTS_DASHBOARD, '/end-user/devices'),
      list: path(ROOTS_DASHBOARD, '/end-user/devices/list'),
      details: path(ROOTS_DASHBOARD, '/end-user/devices/details/:guid')
    },
    reports: {
      list: path(ROOTS_DASHBOARD, '/end-user/reports/list')
    },
    alarms: {
      root: path(ROOTS_DASHBOARD, '/end-user/alarms'),
      list: path(ROOTS_DASHBOARD, '/end-user/alarms/list')
    },
    deviceGroups: {
      root: path(ROOTS_DASHBOARD, '/end-user/device-groups'),
      list: path(ROOTS_DASHBOARD, '/end-user/device-groups/list')
    }
  },
  end_client: {
    dashboard: path(ROOTS_DASHBOARD, '/end-client'),
    devices: {
      details: path(ROOTS_DASHBOARD, '/end-client/devices/details/:guid')
    }
  },
  general: {
    pageOne: path(ROOTS_DASHBOARD, '/one'),
    pageTwo: path(ROOTS_DASHBOARD, '/two'),
    pageThree: path(ROOTS_DASHBOARD, '/three')
  },
  reports: {
    root: path(ROOTS_DASHBOARD, '/reports'),
    list: path(ROOTS_DASHBOARD, '/reports/list'),
    //new: path(ROOTS_DASHBOARD, '/reports/new'),
    alarm_state_change: path(ROOTS_DASHBOARD, '/reports/alarm_state_change')
  },
  devices: {
    root: path(ROOTS_DASHBOARD, '/devices'),
    list: path(ROOTS_DASHBOARD, '/devices/list'),
    new: path(ROOTS_DASHBOARD, '/devices/new'),
    labels: path(ROOTS_DASHBOARD, '/devices/labels'),
    edit: path(ROOTS_DASHBOARD, '/devices/edit/:guid'),
    details: path(ROOTS_DASHBOARD, '/devices/details/:guid')
  },
  alarms: {
    root: path(ROOTS_DASHBOARD, '/alarms'),
    list: path(ROOTS_DASHBOARD, '/alarms/list'),
    new: path(ROOTS_DASHBOARD, '/alarms/new'),
    edit: path(ROOTS_DASHBOARD, '/alarms/edit/:guid'),
    details: path(ROOTS_DASHBOARD, '/alarms/details/:guid')
  },
  assets: {
    root: path(ROOTS_DASHBOARD, '/assets'),
    list: path(ROOTS_DASHBOARD, '/assets/list'),
    new: path(ROOTS_DASHBOARD, '/assets/new')
  },
  delivery_request: {
    root: path(ROOTS_DASHBOARD, '/delivery-request'),
    list: path(ROOTS_DASHBOARD, '/delivery-request/list'),
    new: path(ROOTS_DASHBOARD, '/delivery-request/new')
  },
  deviceGroups: {
    root: path(ROOTS_DASHBOARD, '/device-groups'),
    list: path(ROOTS_DASHBOARD, '/device-groups/list'),
    edit: path(ROOTS_DASHBOARD, '/device-groups/edit/:guid'),
    new: path(ROOTS_DASHBOARD, '/device-groups/new')
  },
  deviceGroupsBuildingsDevices: {
    root: path(ROOTS_DASHBOARD, '/device-groups-buildings-devices'),
    edit: path(ROOTS_DASHBOARD, '/device-groups-buildings-devices/edit/:guid')
  },
  buildings: {
    root: path(ROOTS_DASHBOARD, '/buildings'),
    list: path(ROOTS_DASHBOARD, '/buildings/list'),
    edit: path(ROOTS_DASHBOARD, '/buildings/edit/:guid'),
    new: path(ROOTS_DASHBOARD, '/buildings/new')
  },
  deliveryConfigurations: {
    root: path(ROOTS_DASHBOARD, '/delivery-configurations'),
    list: path(ROOTS_DASHBOARD, '/delivery-configurations/list'),
    edit: path(ROOTS_DASHBOARD, '/delivery-configurations/edit/:guid'),
    new: path(ROOTS_DASHBOARD, '/delivery-configurations/new')
  },
  productTypes: {
    root: path(ROOTS_DASHBOARD, '/product-types'),
    list: path(ROOTS_DASHBOARD, '/product-types/list'),
    edit: path(ROOTS_DASHBOARD, '/product-types/edit/:guid'),
    new: path(ROOTS_DASHBOARD, '/product-types/new')
  },
  productScheduleTemplate: {
    root: path(ROOTS_DASHBOARD, '/product-schedule-template'),
    list: path(ROOTS_DASHBOARD, '/product-schedule-template/list'),
    edit: path(ROOTS_DASHBOARD, '/product-schedule-template/edit/:guid'),
    new: path(ROOTS_DASHBOARD, '/product-schedule-template/new')
  },
  productSchedule: {
    root: path(ROOTS_DASHBOARD, '/product-schedule'),
    list: path(ROOTS_DASHBOARD, '/product-schedule/list'),
    edit: path(ROOTS_DASHBOARD, '/product-schedule/edit/:guid'),
    new: path(ROOTS_DASHBOARD, '/product-schedule/new')
  },
  calculatedData: {
    root: path(ROOTS_DASHBOARD, '/calculated-data'),
    list: path(ROOTS_DASHBOARD, '/calculated-data/list'),
    new: path(ROOTS_DASHBOARD, '/calculated-data/new')
  },
  shared: {
    root: path(ROOTS_DASHBOARD, '/shared'),
    list: path(ROOTS_DASHBOARD, '/shared/list'),
    new: path(ROOTS_DASHBOARD, '/shared/new')
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    settings: path(ROOTS_DASHBOARD, '/user/settings'),
    settings_end_user: path(ROOTS_DASHBOARD, '/end-user/user/settings')
  }
};
